module.exports = __webpack_public_path__ + "static/GriegNightInv.c3130b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/posts/img/GriegNightInv.png
// module id = 1509
// module chunks = 213534597649335